// extracted by mini-css-extract-plugin
export default {"row":"a1RkXO","colTicket":"SxRYsP","colSeatInfo":"rq30HX","colTotal":"ZPvb_z"};